/**
 * The notice that must accompany an expert's text number wherever it is
 * shared. The A2P 10DLC campaign's message flow quotes it, and carriers
 * compare it with the same notice on primum.co/sms, so all three must stay
 * word for word the same. A change here means a change to the campaign's
 * message flow and to `apps/marketing/src/lib/smsTerms.ts` in the same PR.
 */
export const SMS_OPT_IN_NOTICE =
  'By texting this number you agree to receive text messages from Primum Health about your question. Message frequency varies. Msg & data rates may apply. Reply HELP for help, STOP to opt out of all Primum expert numbers.';

/**
 * Formats a North American E.164 number as (555) 010-0100. Anything else is
 * shown as received, since a wrong guess at a format hides a working number.
 */
export function formatSmsNumber(smsNumber: string): string {
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(smsNumber);

  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : smsNumber;
}
